function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "rgb(35, 15, 143)"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.67,
    style: {
      fill: "rgb(255, 255, 255)"
    },
    width: 170.67,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.33,
    style: {
      fill: "rgb(235, 42, 48)"
    },
    width: 170.67,
    height: 512
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGf);
export default __webpack_public_path__ + "static/media/gf.be9c82a708f3c1555201bc5182574686.svg";
export { ForwardRef as ReactComponent };